import React, { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";

const Play = () => {
    const { videoId } = useParams();

    useEffect(() => {
        if (videoId) {
            localStorage.setItem("tempUUID", videoId);
            console.log("Stored UUID in localStorage:", videoId);
        }
    }, [videoId]);

    if (!videoId) {
        return <Navigate to="/home" replace />;
    }

    return <Navigate to={`/home/${videoId}`} replace />;
};

export default Play;
